export const COMPLETE = Symbol('RPC_COMPLETE')

export default {
  COMPLETE
}
